export default {
  title: 'Testrestauranter',
  description:
    'Hver partner kan markere én restaurant som sin testrestaurant. Den fungerer som enhver anden restaurant og faktureres aldrig. Der sendes en Slack-alarm, når dens salg for måneden overstiger tærsklen.',
  empty: 'Ingen partner har en testrestaurant.',
  columns: {
    partner: 'Partner',
    restaurant: 'Restaurant',
    designated: 'Markeret som test',
    gmv: 'GMV denne måned',
  },
  statuses: {
    live: 'Live',
    paused: 'Offline',
    suspended: 'Suspenderet',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Ingen valutakurs gemt',
  },
  actions: {
    remove: 'Fjern test-markering',
  },
  toasts: {
    load_error: 'Testrestauranterne kunne ikke indlæses.',
  },
};
